<template>
    <form action="" @submit.prevent="submitForm" class="w-full h-full text-xs">
        <base-form class="h-full ">
            <template #body>
                <div class='flex flex-row w-full h-full overflow-y-auto'>
                    <div class="w-full h-full min-h-[700px] p-6 flex flex-col">
                        <div class="flex flex-col w-full space-y-2 border-b border-gray-300 pb-4 mb-4 shrink-0">
                            <div class="flex flex-row items-center space-x-2">
                                <label class="w-36 text-sm text-gray-600 tracking-wide">Template Name:</label>
                                <input
                                    type="text"
                                    class="pl-2 border border-gray-300  focus:border-indigo-400 active:border-indigo-400 w-full h-9 rounded"
                                    v-model="emailTemplateForm.email_template_name"
                                />
                            </div>
                            <div class="flex flex-row items-center space-x-2">
                                <label class="w-36 text-sm text-gray-600 tracking-wide">Status:</label>
                                <select 
                                    class="border border-gray-300  focus:border-indigo-400 active:border-indigo-400 w-full h-9 rounded"
                                    v-model="emailTemplateForm.status"
                                    >
                                        <option value="active">Active </option>
                                        <option value="inactive">Inactive</option>
                                </select>
                            </div>
                            <div class="flex flex-row items-center space-x-2">
                                <label class="w-36 text-sm text-gray-600 tracking-wide">Client:</label>
                                <select
                                    class="border border-gray-300  focus:border-indigo-400 active:border-indigo-400 w-full h-9 rounded"
                                    v-model="emailTemplateForm.client_id"
                                >
                                    <option
                                        v-for="client in clientOptions"
                                        :key="client.value"
                                        :value="client.value"
                                    >
                                        {{ client.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="flex flex-row items-center space-x-2">
                                <label class="w-36 text-sm text-gray-600 tracking-wide">CRM Detail Type:</label>
                                <span class="relative group flex items-center shrink-0">
                                    <InformationCircleIcon class="w-4 h-4 text-gray-400 cursor-help" />
                                    <div class="pointer-events-none absolute left-0 top-6 z-30 hidden group-hover:block w-64 p-3 rounded-md bg-gray-800 text-white text-xs font-normal normal-case leading-relaxed shadow-lg">
                                        Only relevant to the new Outreach Drafts flow — when set, sending a draft logs a CRM detail of this type against the company + campaign. The old "Bulk Send Email" (SES) flow ignores it.
                                    </div>
                                </span>
                                <select
                                    class="border border-gray-300  focus:border-indigo-400 active:border-indigo-400 w-full h-9 rounded"
                                    v-model="emailTemplateForm.crm_action_type_id"
                                >
                                    <option :value="null">— None —</option>
                                    <option
                                        v-for="crmType in crmActionTypeOptions"
                                        :key="crmType.value"
                                        :value="crmType.value"
                                    >
                                        {{ crmType.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="flex flex-col space-y-2">
                                <label @click="toggleShowAttachments" class="w-36 text-sm text-gray-600 tracking-wide cursor-pointer hover:underline hover:text-indigo-600 flex items-end space-y-2">
                                    <div>Images</div>
                                    <ChevronDownIcon class="w-5 h-5" v-if="!visibleAttachments" />
                                    <ChevronUpIcon  class="w-5 h-5" v-else />
                                </label>
                                <div v-if="visibleAttachments" class="flex flex-col space-y-2 px-4 py-2 border bg-gray-150 rounded border-gray-300">
                                    <div class="flex flex-row items-start space-x-2">
                                        <label class=" w-36  text-sm whitespace-nowrap  text-gray-600 tracking-wide">Signature Image:</label>
                                        <div class="flex flex-col items-start space-y-2 text-gray-150">
                                            <input
                                                @change="processImage($event, 'signature_image')"
                                                name="signatureFile"
                                                id="signatureFile"
                                                type="file"
                                                accept=".png, .jpg, .jpeg, .svg"
                                                class=""
                                            />
                                            <div class="text-xs text-gray-600 flex flex-col items-start space-y-2">
                                                <div>
                                                    Current File: 
                                                </div>
                                                <div v-if="emailTemplateForm.signature_image"  @click="clearImage('signature_image')" class="cursor-pointer flex p-1 rounded-sm w-fit max-w-[400px] bg-indigo-100 border border-indigo-300 text-indigo-500 hover:bg-indigo-200 hover:text-indigo-600">
                                                    <img :src="emailTemplateForm.signature_image" class="w-20 h-20 object-contain" />
                                                    <div>X</div>
                                                </div>
                                                <div v-else class="text-gray-700">
                                                    No file chosen
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        
                                    <div class="flex flex-row items-start space-x-2">
                                        <label class="w-36 text-sm whitespace-nowrap  text-gray-600 tracking-wide">Logo Image 1:</label>
                                        <div class="flex flex-col items-start space-y-2 text-gray-150">
                                            <input
                                                @change="processImage($event, 'logo_image')"
                                                name="logoImage1"
                                                id="logoImage1"
                                                type="file"
                                                accept=".png, .jpg, .jpeg, .svg"
                                                class=""
                                            />
                                            <div class="text-xs text-gray-600 flex flex-col items-start space-y-2">
                                                <div>
                                                    Current File: 
                                                </div>
                                                <div v-if="emailTemplateForm.logo_image"  @click="clearImage('logo_image')" class="cursor-pointer flex p-1 rounded-sm w-fit max-w-[400px] bg-indigo-100 border border-indigo-300 text-indigo-500 hover:bg-indigo-200 hover:text-indigo-600">
                                                    <img :src="emailTemplateForm.logo_image" class="w-20 h-20 object-contain" />
                                                    <div>X</div>
                                                </div>
                                               <div v-else class="text-gray-700">
                                                    No file chosen
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  
                                    <div class="flex flex-row items-start space-x-2">
                                        <label class=" w-36 text-sm whitespace-nowrap text-gray-600 tracking-wide">Logo Image 2:</label>
                                        <div class="flex flex-col items-start space-y-2  text-gray-150">
                                            <input
                                                @change="processImage($event, 'logo_image_2')"
                                                name="logoImage2"
                                                id="logoImage2"
                                                type="file"
                                                accept=".png, .jpg, .jpeg, .svg"
                                                class=""
                                            />  
                                            <div  class="text-xs text-gray-600 flex flex-col items-start space-y-2">
                                                <div>
                                                    Current File: 
                                                </div>
                                                <div v-if="emailTemplateForm.logo_image_2"  @click="clearImage('logo_image_2')" class="cursor-pointer flex p-1 rounded-sm w-fit max-w-[400px] bg-indigo-100 border border-indigo-300 text-indigo-500 hover:bg-indigo-200 hover:text-indigo-600">
                                                    <img :src="emailTemplateForm.logo_image_2" class="w-20 h-20 object-contain" />
                                                    <div>X</div>
                                                </div>
                                                <div v-else class="text-gray-700">
                                                    No file chosen
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-col space-y-2">
                                <label @click="toggleShowDocuments" class="w-40 text-sm text-gray-600 tracking-wide cursor-pointer hover:underline hover:text-indigo-600 flex items-end space-y-2">
                                    <div class="whitespace-nowrap">Attachments (files)</div>
                                    <ChevronDownIcon class="w-5 h-5" v-if="!visibleDocuments" />
                                    <ChevronUpIcon  class="w-5 h-5" v-else />
                                </label>
                                <div v-if="visibleDocuments" class="flex flex-col space-y-3 px-4 py-3 border bg-gray-150 rounded border-gray-300">
                                    <div class="text-xs text-gray-600">
                                        These files (e.g. a client PDF) are attached to every outreach email sent from this template.
                                    </div>
                                    <template v-if="existingEmailTemplate">
                                        <input
                                            type="file"
                                            multiple
                                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt"
                                            :disabled="uploadingAttachment"
                                            @change="onSelectAttachmentFiles"
                                            class="text-xs"
                                        />
                                        <div v-if="uploadingAttachment" class="text-xs text-indigo-600">Uploading…</div>
                                        <div v-if="attachmentsList.length" class="flex flex-col space-y-1">
                                            <div
                                                v-for="attachment in attachmentsList"
                                                :key="attachment.id"
                                                class="flex items-center justify-between px-2 py-1 bg-white border border-gray-300 rounded text-xs"
                                            >
                                                <a :href="attachment.url" target="_blank" rel="noopener" class="text-indigo-600 hover:underline truncate max-w-[380px]">
                                                    {{ attachment.filename }}
                                                </a>
                                                <div class="flex items-center space-x-3 pl-3">
                                                    <span class="text-gray-500 whitespace-nowrap">{{ formatSize(attachment.size) }}</span>
                                                    <button type="button" @click="removeAttachment(attachment.id)" class="text-gray-400 hover:text-red-600 font-semibold">X</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else class="text-xs text-gray-500">No files attached.</div>
                                    </template>
                                    <div v-else class="text-xs text-gray-500 italic">
                                        Save the template first, then reopen it to add file attachments.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col shrink-0">
                            <div class="flex space-x-2 items-center justify-start h-9">
                                <label class="w-20 text-sm text-gray-600 tracking-wide">From:</label>
                                <select
                                    class="border-b border-gray-300 bg-gray-100 outline-none hover:border-gray-400 active:border-indigo-400 focus:border-indigo-400 h-9 w-full"
                                    v-model="emailTemplateForm.email_from_new_id"
                                >
                                    <option
                                        v-for="email in emailFromOptions"
                                        :key="email.value"
                                        :value="email.value"
                                    >
                                        {{ email.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="flex space-x-2 items-center justify-start h-9">
                                <label class="w-20 text-sm text-gray-600 tracking-wide">To:</label>
                                <span class="relative group flex items-center shrink-0">
                                    <InformationCircleIcon class="w-4 h-4 text-gray-400 cursor-help" />
                                    <div class="pointer-events-none absolute left-0 top-6 z-30 hidden group-hover:block w-64 p-3 rounded-md bg-gray-800 text-white text-xs font-normal normal-case leading-relaxed shadow-lg">
                                        Only relevant to the old "Bulk Send Email" (SES) flow — it's the staging inbox the filled template is sent to for manual cleanup. The new Outreach Drafts flow ignores it.
                                    </div>
                                </span>
                                <select
                                    class="border-b border-gray-300 bg-gray-100 outline-none hover:border-gray-400 active:border-indigo-400 focus:border-indigo-400 h-9 w-full"
                                    v-model="emailTemplateForm.email_to_id"
                                >
                                    <option :value="null">— None —</option>
                                    <option
                                        v-for="email in emailToOptions"
                                        :key="email.value"
                                        :value="email.value"
                                    >
                                        {{ email.label }}
                                    </option>
                                </select>
                            </div>
                            <div class="flex space-x-2 items-center justify-start h-9">
                                <label class="w-20 text-sm text-gray-600 tracking-wide">Bcc:</label>
                                <input
                                    type="text"
                                    class="border-b border-gray-300 bg-gray-100 outline-none hover:border-gray-400 active:border-indigo-400 focus:border-indigo-400 h-9 w-full"
                                    v-model="emailTemplateForm.email_bcc"
                                />
                            </div>
                            <div class="flex space-x-2 items-center justify-start h-9">
                                <label class="w-20 text-sm text-gray-600 tracking-wide">Subject:</label>
                                <input
                                    type="text"
                                    class="border-b border-gray-300 bg-gray-100 outline-none hover:border-gray-400 active:border-indigo-400 focus:border-indigo-400 h-9 w-full"
                                    v-model="emailTemplateForm.subject"
                                />
                            </div>
                        </div>
                        <div class="w-full flex-1 min-h-0 flex flex-col">
                            <div class="flex flex-row items-center space-x-2 justify-between h-11 shrink-0">
                                <div class="flex items-center justify-start space-x-2">
                                    <label class="w-20 text-sm text-gray-600 tracking-wide">Body:</label>
                                    <div class="flex space-x-2 items-center">
                                        <div class="text-gray-600 text-xs tracking-wider whitespace-nowrap">Rich Text</div>
                                        <Switch
                                            v-model="viewRawEmailBody"
                                            :class="viewRawEmailBody ? 'bg-dark-secondary border border-dark-primary pr-6' : 'bg-gray-300 border border-gray-400 pr-6'"
                                            class="relative inline-flex h-5 w-11 items-center rounded-full"
                                        >
                                            <span class="sr-only">View Raw Email Body</span>
                                            <span
                                                :class="viewRawEmailBody ? 'translate-x-6 border-dark-primary' : 'translate-x-0.5 border-gray-400'"
                                                class="inline-block h-4 w-4 transform rounded-full bg-white border  transition"></span>
                                        </Switch>
                                        <div class="text-gray-600 text-xs tracking-wider whitespace-nowrap">Raw HTML</div>
                                    </div>
                                </div>
                                <div class="flex justify-end items-center gap-4">
                                    <button class="flex justify-end items-center hover:underline hover:text-indigo-500 text-indigo-600 cursor-pointer text-sm"  @click.prevent="toggleShowInterpretationFields">
                                        <div class="whitespace-nowrap">
                                            {{ visibleInterpretationFields ? 'Hide AI Interpretation Fields' : 'View AI Interpretation Fields' }}
                                        </div>
                                        <ChevronLeftIcon class="w-5 h-5" v-if="visibleInterpretationFields" />
                                        <ChevronRightIcon class="w-5 h-5" v-else />
                                    </button>
                                    <button class="flex justify-end items-center hover:underline hover:text-indigo-500 text-indigo-600 cursor-pointer text-sm"  @click.prevent="toggleShowInjectableFields">
                                        <div class="whitespace-nowrap">
                                            {{ visibleInjectableFields ? 'Hide Injectable Fields' : 'View Injectable Fields' }}
                                        </div>
                                        <ChevronLeftIcon class="w-5 h-5" v-if="visibleInjectableFields" />
                                        <ChevronRightIcon class="w-5 h-5" v-else />
                                    </button>
                                </div>
                            </div>
                            <div ref="emailBodyContainer" class="w-full flex flex-row flex-1 min-h-0 pt-2" :class="emailBodyContainerClass">
                                <div v-if="viewRawEmailBody" class="w-full h-full">
                                    <textarea
                                        class="bg-white w-full rounded-md border border-gray-300 p-4 h-full"
                                        v-model="emailTemplateForm.email_body"
                                        rows="13"
                                    ></textarea>
                                </div>
                                <div v-else class="w-full h-full">
                                    <rich-text-editor
                                        class="bg-white w-full overflow-y-auto rounded-md border border-gray-300 relative h-full"
                                        v-model="emailTemplateForm.email_body"
                                    />
                                </div>
                                <div v-if="visibleInjectableFields" class="w-[550px] pl-4 h-full overflow-y-auto">
                                    <email-template-fields-table class="w-full"  />
                                </div>
                                <div v-if="visibleInterpretationFields" class="w-[550px] pl-4 h-full overflow-y-auto">
                                    <LLMInterpretationFieldsTable class="w-full" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="h-10 px-2 flex items-center justify-center space-x-2">
                    <BaseButton v-if="validForm" type="submit">{{ existingEmailTemplate ? 'Save' : 'Create' }}</BaseButton>
                    <BaseButtonDisabled v-else>{{ existingEmailTemplate ? 'Save' : 'Create' }}</BaseButtonDisabled>
                    <BaseButtonCancel type="button" @click="close">Cancel</BaseButtonCancel>
                </div>
            </template>
        </base-form>
    </form>
</template>

<script setup>
import {defineProps, defineEmits, ref, computed, reactive, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import { uploadEmailTemplateAttachments, deleteEmailTemplateAttachment } from '@/services/EmailTemplates';
import { getActions } from '@/services/CrmAction';
import RichTextEditor from '../base-components/RichTextEditor.vue';
import BaseButton from '../base-components/BaseButton.vue';
import BaseButtonDisabled from '../base-components/BaseButtonDisabled.vue';
import BaseButtonCancel from '../base-components/BaseButtonCancel.vue';
import EmailTemplateFieldsTable from './EmailTemplateFieldsTable.vue';
import LLMInterpretationFieldsTable from './LLMInterpretationFieldsTable.vue';
import { ChevronDownIcon, ChevronUpIcon, ChevronRightIcon, ChevronLeftIcon, InformationCircleIcon } from '@heroicons/vue/20/solid';
import { Switch } from '@headlessui/vue';

const props = defineProps(['clientOptions', 'emailToOptions', 'emailFromOptions', 'userPermissions', 'existingEmailTemplate'])
const emit = defineEmits(['close', 'submit-form'])

const store = useStore()
const $toast = useToast()

const emailTemplateForm = reactive({
    email_template_name: props.existingEmailTemplate ? props.existingEmailTemplate.email_template_name : null,
    status:  props.existingEmailTemplate ? props.existingEmailTemplate.status : 'active',
    client_id: props.existingEmailTemplate && props.existingEmailTemplate.client ? props.existingEmailTemplate.client.id : null,
    crm_action_type_id: props.existingEmailTemplate && props.existingEmailTemplate.crm_action_type ? props.existingEmailTemplate.crm_action_type.id : null,
    email_to_id: props.existingEmailTemplate && props.existingEmailTemplate.email_to ? props.existingEmailTemplate.email_to.id : null,
    email_from_new_id: props.existingEmailTemplate && props.existingEmailTemplate.email_from_new ? props.existingEmailTemplate.email_from_new.id : null,
    email_bcc: props.existingEmailTemplate ? props.existingEmailTemplate.email_bcc : null,
    subject: props.existingEmailTemplate ? props.existingEmailTemplate.subject : null,
    email_body: props.existingEmailTemplate ? props.existingEmailTemplate.email_body : null,
    signature_image: props.existingEmailTemplate ? props.existingEmailTemplate.signature_image : null,
    logo_image: props.existingEmailTemplate ? props.existingEmailTemplate.logo_image : null,
    logo_image_2: props.existingEmailTemplate ? props.existingEmailTemplate.logo_image_2 : null,
})

const modifiedImageMapping = reactive({
    signature_image: false,
    logo_image: false,
    logo_image_2: false
})

const emailBodyContainer = ref(null);

const emailBodyContainerClass = ref(null);

const useNewEmailTemplate = ref(false);

const visibleInjectableFields = ref(false);

const visibleInterpretationFields = ref(false);

const visibleAttachments = ref(false);

const visibleDocuments = ref(false);

const attachmentsList = ref(props.existingEmailTemplate && props.existingEmailTemplate.attachments ? [...props.existingEmailTemplate.attachments] : []);

const uploadingAttachment = ref(false);

const viewRawEmailBody = ref(false);

const crmActionTypeOptions = ref([]);

// const previousSignatureImage = ref(props.existingEmailTemplate && props.existingEmailTemplate.signature_image ? props.existingEmailTemplate.signature_image : null);

// const previousLogoImage = ref(props.existingEmailTemplate && props.existingEmailTemplate.logo_image ? props.existingEmailTemplate.logo_image : null);

// const previousLogo2Image = ref(props.existingEmailTemplate && props.existingEmailTemplate.logo_image_2 ? props.existingEmailTemplate.logo_image_2 : null);

onMounted(() => {
    emailBodyContainerClass.value = '';
    loadCrmActionTypeOptions();
})

async function loadCrmActionTypeOptions() {
    try {
        const res = await getActions(store.state.auth.token)
        crmActionTypeOptions.value = (res.data || []).map((action) => ({ value: action.id, label: action.action_name }))
    } catch (e) {
        console.log(e)
    }
}

const validForm = computed(() => {
    return emailTemplateForm.email_template_name !== null &&
        emailTemplateForm.status !== null &&
        emailTemplateForm.email_from_new_id !== null &&
        // emailTemplateForm.subject !== null &&
        emailTemplateForm.email_body !== null
})

watch(() => emailTemplateForm.data_source_id, () => {
    if(emailTemplateForm.data_source_id == -1) {
        useNewEmailTemplate.value = true
    } else {
        useNewEmailTemplate.value = false
    }
})

watch(() => props.existingEmailTemplate, () => {
    if(props.existingEmailTemplate) {
        refreshEmailTemplateForm()
    }
})

function clearImage(key) {
    console.log('clearImage', key)
    emailTemplateForm[key] = null
    modifiedImageMapping[key] = true
    console.log(modifiedImageMapping)
}

function toggleShowInjectableFields() {
    visibleInjectableFields.value = !visibleInjectableFields.value
    // keep only one reference panel open at a time
    if (visibleInjectableFields.value) visibleInterpretationFields.value = false
}

function toggleShowInterpretationFields() {
    visibleInterpretationFields.value = !visibleInterpretationFields.value
    if (visibleInterpretationFields.value) visibleInjectableFields.value = false
}

function toggleShowAttachments() {
    visibleAttachments.value = !visibleAttachments.value
}

function toggleShowDocuments() {
    visibleDocuments.value = !visibleDocuments.value
}

async function onSelectAttachmentFiles(event) {
    const files = event.target.files
    if (!files || !files.length) return
    uploadingAttachment.value = true
    try {
        const token = store.state.auth.token
        const created = await uploadEmailTemplateAttachments(token, props.existingEmailTemplate.id, files)
        attachmentsList.value = [...attachmentsList.value, ...created]
        $toast.open({
            message: `Attached ${created.length} file${created.length === 1 ? '' : 's'}`,
            type: 'success',
            duration: 3000
        })
    } catch (e) {
        $toast.open({ message: 'Could not upload attachment', type: 'error', duration: 5000 })
    } finally {
        uploadingAttachment.value = false
        event.target.value = '' // reset so the same file can be re-selected
    }
}

async function removeAttachment(attachmentId) {
    try {
        const token = store.state.auth.token
        await deleteEmailTemplateAttachment(token, props.existingEmailTemplate.id, attachmentId)
        attachmentsList.value = attachmentsList.value.filter((a) => a.id !== attachmentId)
        $toast.open({ message: 'Attachment removed', type: 'success', duration: 2000 })
    } catch (e) {
        $toast.open({ message: 'Could not remove attachment', type: 'error', duration: 5000 })
    }
}

function formatSize(bytes) {
    if (bytes === null || bytes === undefined) return ''
    if (bytes < 1024) return `${bytes} B`
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

function refreshEmailTemplateForm() {
    emailTemplateForm.email_template_name = props.existingEmailTemplate ? props.existingEmailTemplate.email_template_name : null;
    emailTemplateForm.status = props.existingEmailTemplate ? props.existingEmailTemplate.template_name : 'active';
    emailTemplateForm.client_id = props.existingEmailTemplate && props.existingEmailTemplate.client ? props.existingEmailTemplate.client.id : null;
    emailTemplateForm.crm_action_type_id = props.existingEmailTemplate && props.existingEmailTemplate.crm_action_type ? props.existingEmailTemplate.crm_action_type.id : null;
    emailTemplateForm.email_to_id = props.existingEmailTemplate && props.existingEmailTemplate.email_to ? props.existingEmailTemplate.email_to.id : null;
    emailTemplateForm.email_from_new_id = props.existingEmailTemplate ? props.existingEmailTemplate.email_from : null;
    emailTemplateForm.email_bcc = props.existingEmailTemplate ? props.existingEmailTemplate.email_bcc : null;
    emailTemplateForm.subject = props.existingEmailTemplate ? props.existingEmailTemplate.subject : null;
    emailTemplateForm.email_body = props.existingEmailTemplate ? props.existingEmailTemplate.email_body : null;
    emailTemplateForm.signature_image = props.existingEmailTemplate ? props.existingEmailTemplate.signature_image : null;
    emailTemplateForm.logo_image = props.existingEmailTemplate ? props.existingEmailTemplate.logo_image : null;
    emailTemplateForm.logo_image_2 = props.existingEmailTemplate ? props.existingEmailTemplate.logo_image_2 : null;
    attachmentsList.value = props.existingEmailTemplate && props.existingEmailTemplate.attachments ? [...props.existingEmailTemplate.attachments] : [];
}

function processImage(event, key) {
    console.log('processImage', event, key)
    if (event.target.files && event.target.files[0]) {
        emailTemplateForm[key] = event.target.files[0]
    } else {
        emailTemplateForm[key] = null
    }
    modifiedImageMapping[key] = true
    console.log(modifiedImageMapping)
}

function cleanEmailTemplateBody() {
    emailTemplateForm.email_body = emailTemplateForm.email_body.replaceAll('&lt;', '<').replaceAll('&gt;', '>')
}


function submitForm() {
    // console.log('submit')
    const formData = new FormData()
    const imageFields = ['signature_image', 'logo_image', 'logo_image_2']
    cleanEmailTemplateBody()
    for(const [key, value] of Object.entries(emailTemplateForm)) {
        if(imageFields.includes(key)) {
            if(modifiedImageMapping[key] == true) {
                if(value) {
                    formData.append(key, value, value.name)
                } else {
                    formData.append(key, null)
                }
            }
        } else {
            if(value) {
                formData.append(key, value)
            }
        }
    }
    // Always send crm_action_type_id and email_to_id (even empty) so they can be
    // cleared; the generic loop above skips falsy values, which would make
    // "None" a no-op.
    formData.set('crm_action_type_id', emailTemplateForm.crm_action_type_id ?? '')
    formData.set('email_to_id', emailTemplateForm.email_to_id ?? '')
    formData.set('subject', emailTemplateForm.subject ?? null)
    // console.log(formData)
    emit('submit-form', formData)
}

function close() {
    // console.log('EmailTemplateForm: close')
    emit('close')
}

</script>